module.exports = __webpack_public_path__ + "static/media/header-background.1b7d6a99.jpg";